import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PartyPopperIcon } from 'lucide-react';
type CompletionProps = {
  allDone: boolean;
};
export function Completion({
  allDone
}: CompletionProps) {
  return <AnimatePresence initial={false} data-id="element-30" data-mp="25fj2jfpfp0hb">
      {allDone && <motion.section key="completion" initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -8
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="rounded-4xl border border-mint/40 bg-mint/5 p-6 sm:p-8" aria-live="polite" data-id="element-31" data-mp="21deb8nmgkfxu">
          <div className="flex items-start gap-4" data-id="element-32" data-mp="2p27bgwa459y9">
            <PartyPopperIcon className="mt-1 h-6 w-6 shrink-0 text-mint" aria-hidden="true" data-id="element-33" data-mp="2k3w20mnqd1gk" />
            <div data-id="element-34" data-mp="2y35h1j079piy">
              <h2 className="text-xl font-bold tracking-tight text-ink sm:text-2xl" data-id="element-35" data-mp="2y2nbtwvk80yw">
                ¡Listo! Hiciste las cinco verificaciones
              </h2>
              <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-36" data-mp="2t2heq16itm9f">
                Tu iPhone ya está mejor configurado que el de muchísima gente.
              </p>
            </div>
          </div>
        </motion.section>}
    </AnimatePresence>;
}